angular.module('internal.vehiclebookings', [])
    .config(['$stateProvider',
        /**
         * @param {ui.IStateProvider} $stateProvider
         */
        function ($stateProvider) {
            $stateProvider.state('internal.vehiclebookings', {
                url: '/vehiclebookings/:scrollTop/:id',
                views: {
                    content: {
                        templateUrl: 'js/internal/vehiclebookings/booking-list/vehiclebookings.html',
                        controller: 'VehiclebookingsController',
                        controllerAs: 'vm'
                    }
                }
            });

            // Add/Edit
            $stateProvider.state('internal.editbooking', {
                url: '/edit-booking/:id/:vehicleBooking/:prevState/:state',
                views: {
                    content: {
                        templateUrl: 'js/internal/vehiclebookings/edit-booking/booking.html',
                        controller: 'EditBookingController',
                        controllerAs: 'vm'
                    }
                }
            });

            // View details
            $stateProvider.state('internal.booking-details', {
                url: '/booking-details/:id/:prevState/:state',
                views: {
                    content: {
                        templateUrl: 'js/internal/vehiclebookings/booking-details/booking-details.html',
                        controller: 'BookingDetailsController',
                        controllerAs: 'vm'
                    }
                }
            });


            // calendar (add new vehicle booking)
            $stateProvider.state('internal.addvehiclebooking', {
                url: '/addvehiclebooking/:startDate/:scrollTop',
                views: {
                    content: {
                        templateUrl: 'js/internal/vehiclebookings/addvehiclebooking/addvehiclebooking.html',
                        controller: 'AddVehicleBookingController',
                        controllerAs: 'vm'
                    }
                }
            });
            
            // returned
            $stateProvider.state('internal.return', {
                url: '/return/:id/:state',
                views: {
                    content: {
                        templateUrl: 'js/internal/vehiclebookings/pickup/pickup.html',
                        controller: 'ReturnController',
                        controllerAs: 'vm'
                    }
                }
            });
            
            //pickup
            $stateProvider.state('internal.pickup', {
                url: '/pickup/:id/:state',
                views: {
                    content: {
                        templateUrl: 'js/internal/vehiclebookings/pickup/pickup.html',
                        controller: 'PickupController',
                        controllerAs:'vm'
                    }
                }
            });


        }]);